import { axios } from '@/utils/http'
import {
  StudentPhotoVModel,
  StudentPhotoUpload
} from '@/models/studentPhoto/studentPhoto'
import { TableResponse, Params } from '@/components/table'
import { paramsApdapter } from '@/utils/apdapter'
import { HttpRequestOptions } from 'element-ui/types/upload'
import { createProcessHandler } from '@/utils/upload'
import { post as upload } from '@/api/exam/upload'
import { notify } from '@/utils/notification'
const API_URL = `studentphoto`

export async function getList(
  limit?: number,
  offset?: number,
  ok?: number,
  account?: string
) {
  const url = `${API_URL}/dataList?limit=${limit}&offset=${offset}&ok=${ok}&account=${account}`
  const { data } = await axios.get(url)
  return data as TableResponse<StudentPhotoVModel>
}

export async function getPhoto(UserId: string) {
  const url = `${API_URL}/zipedphoto/${UserId}`
  const { data } = await axios.get(url, { responseType: 'blob' })
  return new Blob([data], {
    type: 'image/jpeg'
  })
}

export async function getZipByType(type: number = 1) {
  const url = `${API_URL}/zipedfile/${type}`
  const { data } = await axios.get(url, { responseType: 'blob' })
  return new Blob([data], {
    type: 'application/x-zip-compressed'
  })
}

export async function editstatus(UserId?: string, Ok?: number) {
  const url = `${API_URL}/editstatus/${UserId}/${Ok}`
  const { data } = await axios.post(url)
  return data as StudentPhotoUpload
}

export async function uploadStatus(option: HttpRequestOptions) {
  try {
    const count = await upload(
      `${API_URL}/Import`,
      option.file,
      createProcessHandler(option)
    )
    notify(`上传成功, 共${count}条数据`)
    return true
  } catch (e) {
    notify('上传失败', e)
    return false
  }
}
